"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WearableCategory = void 0;
const validation_1 = require("../validation");
var WearableCategory;
(function (WearableCategory) {
    WearableCategory["EYEBROWS"] = "eyebrows";
    WearableCategory["EYES"] = "eyes";
    WearableCategory["FACIAL_HAIR"] = "facial_hair";
    WearableCategory["HAIR"] = "hair";
    WearableCategory["MOUTH"] = "mouth";
    WearableCategory["UPPER_BODY"] = "upper_body";
    WearableCategory["LOWER_BODY"] = "lower_body";
    WearableCategory["FEET"] = "feet";
    WearableCategory["EARRING"] = "earring";
    WearableCategory["EYEWEAR"] = "eyewear";
    WearableCategory["HAT"] = "hat";
    WearableCategory["HELMET"] = "helmet";
    WearableCategory["MASK"] = "mask";
    WearableCategory["TIARA"] = "tiara";
    WearableCategory["TOP_HEAD"] = "top_head";
    WearableCategory["GUN"] = "gun";
    WearableCategory["PIPE"] = "pipe";
    WearableCategory["BONG"] = "bong";
    WearableCategory["CIGAR"] = "cigar";
    WearableCategory["JOINT"] = "joint";
    WearableCategory["BEER"] = "beer";
    WearableCategory["BALLOONS"] = "balloons";
    WearableCategory["GUITAR"] = "guitar";
    WearableCategory["GAMING"] = "gaming";
    WearableCategory["HEADPHONES"] = "headphones";
    WearableCategory["SOCCER"] = "soccer";
    WearableCategory["BASKETBALL"] = "basketball";
    WearableCategory["GOLF"] = "golf";
    WearableCategory["SNOWBOARD"] = "snowboard";
    WearableCategory["SKIS"] = "skis";
    WearableCategory["SKATEBOARD"] = "skateboard";
    WearableCategory["ROLLERSKATES"] = "rollerskates";
    WearableCategory["WEIGHTS"] = "weights";
    WearableCategory["HOTDOG"] = "hotdog";
    WearableCategory["PIZZA"] = "pizza";
    WearableCategory["ICE_CREAM"] = "ice_cream";
    WearableCategory["BURGER"] = "burger";
    WearableCategory["TACO"] = "taco";
    WearableCategory["DOG"] = "dog";
    WearableCategory["CAT"] = "cat";
    WearableCategory["PANDA"] = "panda";
    WearableCategory["DRAGON"] = "dragon";
    WearableCategory["SHARK"] = "shark";
    WearableCategory["DOLPHIN"] = "dolphin";
    WearableCategory["BIRD"] = "bird";
    WearableCategory["FISH"] = "fish";
})(WearableCategory = exports.WearableCategory || (exports.WearableCategory = {}));
(function (WearableCategory) {
    WearableCategory.schema = {
        type: 'string',
        enum: Object.values(WearableCategory),
    };
    WearableCategory.validate = validation_1.generateValidator(WearableCategory.schema);
})(WearableCategory = exports.WearableCategory || (exports.WearableCategory = {}));
//# sourceMappingURL=wearable-category.js.map